import { useState } from 'react';
import { submitFeedback, type FeedbackInput } from '../lib/feedback';
import { track } from '../lib/telemetry';

export function useFeedback(): {
  submit: (input: FeedbackInput) => Promise<void>;
  isSubmitting: boolean;
  error: string | null;
} {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (input: FeedbackInput): Promise<void> => {
    setIsSubmitting(true);
    setError(null);
    try {
      await submitFeedback(input);
      track('feedback.submitted', 'feature_use', {
        feedbackType: input.feedbackType,
      });
    } catch {
      setError("Couldn't submit feedback — please try again");
      throw new Error("Couldn't submit feedback — please try again");
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submit, isSubmitting, error };
}
